import React from 'react';
import Styled from 'styled';
import { Link } from 'react-router-dom';

import tag from 'four-nets/icons/svg/icon_tag.svg';
import place from 'four-nets/icons/svg/icon_place.svg';

import { VendorSummaryInfoFragment } from './vendor-summary-info.graphql';
import AuthorSVGIcon from '../author-svg-icon/author-svg-icon';
import defaultStyles from './vendor-summary-info.scss';

export interface Props extends VendorSummaryInfoFragment {
    styles: typeof defaultStyles;
}

function VendorSummaryInfo(props: Props) {
    const { styles, category, county } = props;
    return (
        <React.Fragment>
            {category && category.name ? (
                <Link to={`/catalog/category/${category.slug}`} className={styles.categoryLink}>
                    <AuthorSVGIcon src={tag} />
                    <span className={styles.vendorInfo}>{category.name}</span>
                </Link>
            ) : null}
            {county ? (
                <div>
                    <AuthorSVGIcon src={place} />
                    <span className={styles.vendorInfo}>{county.name}</span>
                </div>
            ) : null}
        </React.Fragment>
    );
}

export default Styled(defaultStyles)(VendorSummaryInfo);
